let showData = {};
let what = 'body';

// Micro State machine, jumps to state if allowed
const microMachine = {
  /**
   * if state exists and it can be reached from current state, enters on the new state
   *
   * @param {*} { target, state }
   */
  async gotoState({ target, state, states }) {
    const currentState = target.dataset.interactionState;

    if (states[currentState]?.allowed.includes(state)) {
      if (states[currentState].exit) {
        await states[currentState].exit(target);
      }

      setDataInteractionStateTo(target, state);
      // Passing target to be available on the implementation
      states[state].enter(target);
    }
  },
};

/**
 * updates target to a new data-interaction-state
 *
 * @param {*} target
 * @param {*} state
 */
function setDataInteractionStateTo(target, state) {
  const element = target;
  element.dataset.interactionState = state;
}

/**
 * Inits the state machine in standard interaction way
 *
 * @param {*} item
 * @param {*} interactionName
 * @param {*} states
 */
function init(item, interactionName, states) {
  const triggerEvent = `${interactionName}-event`;

  if (item) {
    what = item;
  }

  showData = {
    what,
    triggerEvent,
  };

  // on transition state event tries to move all targets to a new state
  $(what).on(`${triggerEvent}`, (e, data) => {
    Array.from(data.target).forEach(($element) => {
      microMachine.gotoState({ target: $element, state: data.state, states });
    });
  });
}
/**
 * Destroy standard
 *
 */
function destroy() {
  $(showData.what).off(showData.triggerEvent);
}

module.exports = {
  init,
  destroy,
};
